import React, { useState } from "react";
import { Button, Container, Center } from "@chakra-ui/react";


import { FaqList } from "../Faq/components/listFaq";

export default function Faq() {

    return (
        <Container maxW="xxl" mt={100}>
            <FaqList />
        </Container>
    );
}
